import ResourcePage from "@/components/common/ResourcePage";
import { useMeta } from "@/context/MetaContext";
import { money } from "@/lib/api";

export default function Suppliers() {
  const { options } = useMeta();
  const fields = [
    { name: "name", label: "Supplier Name", required: true },
    { name: "category", label: "Category", type: "select", span: 1, options: options("supplier_category") },
    { name: "phone", label: "Phone", span: 1 },
    { name: "email", label: "Email", span: 1 },
    { name: "gst", label: "GST / Tax ID", span: 1 },
    { name: "outstanding", label: "Opening Outstanding", type: "number", span: 1, step: "0.01", default: 0 },
  ];
  const columns = [
    { key: "name", label: "Supplier", sortable: true, render: (r) => <span className="font-medium">{r.name}</span> },
    { key: "category", label: "Category" },
    { key: "phone", label: "Phone" },
    { key: "email", label: "Email" },
    { key: "outstanding", label: "Outstanding", className: "text-right", cellClassName: "tabular text-right", render: (r) => money(r.outstanding) },
  ];
  return (
    <ResourcePage title="Suppliers" subtitle="Vendor directory, categories and outstanding balances."
      endpoint="suppliers" module="suppliers" columns={columns} fields={fields}
      searchPlaceholder="Search suppliers…" emptyHint="Add suppliers to raise purchase orders." />
  );
}
